import Vue from 'vue';
import VueGtm from 'vue-gtm';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

// GTM ID が未設定のローカル環境では読み込みをスキップする
if (process.env.VUE_APP_GTM_ID && process.env.VUE_APP_HOST !== 'https://dev.donbler.com') {
  Vue.use(VueGtm, { id: process.env.VUE_APP_GTM_ID });
}

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
